/**
 * The service for modals.
 * Contains all the methods needed for managing modals.
 */
var ModalService = /** @class */ (function () {
    /*@ngInject*/
    function ModalService($uibModalStack, $timeout) {
        this.$uibModalStack = $uibModalStack;
        this.$timeout = $timeout;
    }
    ModalService.prototype.isAnyModalOpen = function () {
        return this.$uibModalStack.getTop();
    };
    ModalService.prototype.addModalOpenClassToBodyIfAnyModalIsOpen = function () {
        if (this.isAnyModalOpen()) {
            // add back modal-open class to body to enable scrolling of the modal
            this.$timeout(function () {
                $('body').addClass('modal-open');
            }, 500);
        }
    };
    ModalService.prototype.closeAllOpenModals = function () {
        this.$uibModalStack.dismissAll();
    };
    return ModalService;
}());
export { ModalService };
//# sourceMappingURL=modalService.js.map